import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "marketing-service";

const GET_ALL_MARKETING_SERVICE_URL = `${prefix}/all`;
const CREATE_MARKETING_SERVICE_URL = `${prefix}/create`;
const UPDATE_MARKETING_SERVICE_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_MARKETING_SERVICE_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllMarketingService
 * @desc get all service data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} service array
 */
export const getAllMarketingService = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_MARKETING_SERVICE_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllMarketingService");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllMarketingService */

/**
 * @func createMarketingService
 * @desc create new service
 * @author izeberg
 * @param {Object} body - create service body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} create status
 */
export const createMarketingService = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_MARKETING_SERVICE_URL, body, {
            signal,
        });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createMarketingService");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createMarketingService */

/**
 * @func updateMarketingServiceById
 * @desc update service by id
 * @author izeberg
 * @param {number} id - service id
 * @param {Object} body - update service body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateMarketingServiceById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_MARKETING_SERVICE_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateMarketingServiceById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateMarketingServiceById */

/**
 * @func deleteMarketingServiceById
 * @desc delete service by id
 * @author izeberg
 * @param {Object} body - create service body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} service array
 */
export const deleteMarketingServiceById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_MARKETING_SERVICE_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteMarketingServiceById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteMarketingServiceById */
